import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductBoxClose = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.8457 6.74763L12.3457 2.33453C12.1289 2.22223 11.8711 2.22223 11.6543 2.33453L3.1543 6.74763C2.9058 6.87653 2.75 7.13333 2.75 7.41313V16.2402C2.75 16.5205 2.9058 16.7763 3.1543 16.9062L11.6543 21.3203C11.7627 21.376 11.8814 21.4043 12 21.4043C12.1186 21.4043 12.2373 21.376 12.3457 21.3203L20.8457 16.9062C21.0937 16.7763 21.25 16.5205 21.25 16.2402V7.41313C21.25 7.13333 21.0938 6.87653 20.8457 6.74763ZM12 3.84523L19.1447 7.55443L16.5212 8.91593L9.3772 5.20693L12 3.84523ZM11.5 19.5499L4.25 15.7842V8.36613L11.5 12.1311V19.5499ZM12 11.2637L4.8562 7.55403L7.7496 6.05193L14.8938 9.76113L12 11.2637ZM19.75 15.7842L12.5 19.5499V12.1311L19.75 8.36693V15.7842Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductBoxClose.displayName = 'ProductBoxClose';
